module.exports = __webpack_public_path__ + "img/landingUpload.cc05aac1.png";